import { useQuery } from "@tanstack/react-query";
import { getAssetGroups, getInventory, getUnknownAssets } from "../../api";

export const useGetInventory = (page) => {
  const query = useQuery({
    queryKey: ["inventory", page],
    queryFn: () => getInventory(page),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetAssetGroups = (page) => {
  const query = useQuery({
    queryKey: ["asset_groups", page],
    queryFn: () => getAssetGroups(page),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetUnknownAssets = (page) => {
  const query = useQuery({
    queryKey: ["unknown_assets", page],
    queryFn: () => getUnknownAssets(page),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

